import { game_skill_position } from '../api/entities';

export const actions = {
  listGameSkillPosition: 'LIST_GAME_SKILL_POSITION',
};

export function getGameSkillPositions() {
  return game_skill_position.list(actions.listGameSkillPosition, null, null, true);
}

const INITIAL_STATE = {
  game_skill_positions: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.listGameSkillPosition:
      return {
        ...state,
        game_skill_positions: action.body ? action.body._items : state.game_skill_positions,
      };
    default:
      return {
        ...state,
      };
  }
}
